import ForgotPasswordFinish from '../../../auth/components/forgot-password/ForgotPasswordFinish';

export default function ForgotPasswordFinishPage() {
    return <ForgotPasswordFinish />;
}
